export default "__VITE_ASSET__fQO3y5RP__"